import { SVGProps } from 'react';

const IdCardLanyard = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M13.5 8h-3M15 2l-1 2h3a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h3m6.899 18A5 5 0 0 0 7.1 22M9 2l3 6m3 7a3 3 0 1 1-6 0 3 3 0 0 1 6 0"
    />
  </svg>
);
export default IdCardLanyard;
